import {
  Alert,
  Button,
  Card,
  Center,
  Group,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  ThemeIcon,
  Title,
} from '@mantine/core';
import { IconAlertTriangle, IconWallet } from '@tabler/icons-react';
import { useState } from 'react';
import type { FormEvent } from 'react';

import { ApiError } from '../api/client';
import { useLogin } from '../api/queries';

/** Shown instead of the ledger while nobody is logged in. */
export function LoginScreen() {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const { mutate, isPending, error, reset } = useLogin();

  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    mutate({ login: login.trim(), password });
  };

  return (
    <Center mih="100dvh" px="md">
      <Card padding="xl" radius="md" w={360} withBorder>
        <form onSubmit={submit}>
          <Stack gap="lg">
            <Group gap="sm" wrap="nowrap">
              <ThemeIcon size={42} radius="md" variant="light">
                <IconWallet size={22} stroke={1.5} />
              </ThemeIcon>
              <div>
                <Title order={3}>ledger</Title>
                <Text size="sm" c="dimmed">
                  Вход для своих
                </Text>
              </div>
            </Group>

            {error !== null && (
              <Alert
                color="red"
                variant="light"
                icon={<IconAlertTriangle size={18} stroke={1.5} />}
              >
                {failureMessage(error)}
              </Alert>
            )}

            <Stack gap="sm">
              <TextInput
                label="Логин"
                value={login}
                autoComplete="username"
                autoFocus
                required
                onChange={(event) => {
                  setLogin(event.currentTarget.value);
                  reset();
                }}
              />
              <PasswordInput
                label="Пароль"
                value={password}
                autoComplete="current-password"
                required
                onChange={(event) => {
                  setPassword(event.currentTarget.value);
                  reset();
                }}
              />
            </Stack>

            <Button type="submit" loading={isPending} disabled={login === '' || password === ''}>
              Войти
            </Button>
          </Stack>
        </form>
      </Card>
    </Center>
  );
}

/** The API answers in English and says no more than it should — the wording is ours. */
function failureMessage(error: Error): string {
  if (error instanceof ApiError && error.isUnauthorized) {
    return 'Неверный логин или пароль';
  }
  if (error instanceof ApiError && error.isNotFound) {
    return 'На этом сервисе вход не настроен';
  }
  return error instanceof ApiError ? error.message : 'Не удалось войти';
}
